import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { CONTACT } from "../../mock";

export const IntroStrip = () => (
  <section className="bg-[#b6a4a7] py-16 md:py-20">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <Reveal>
        <p className="font-sans-el tracking-[0.4em] uppercase text-white/80 text-xs mb-5">
          {CONTACT.area}
        </p>
        <p className="font-serif-el text-white text-2xl md:text-3xl leading-relaxed">
          Delivering a remarkable home selling and buying experience across the
          Greater Chester and Delaware Counties.
        </p>
        <Link
          to="/current-listings"
          className="btn-mauve inline-flex items-center gap-2 mt-9 px-8 py-3.5 rounded-sm"
          style={{ backgroundColor: "#3a3736" }}
        >
          View Current Listings <ArrowRight size={16} />
        </Link>
      </Reveal>
    </div>
  </section>
);

export const HomeCTA = () => (
  <section className="relative py-24 md:py-32 overflow-hidden">
    <img
      src="/images/hero2.jpg"
      alt="Beautiful home exterior"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0" style={{ background: "rgba(58,55,54,0.6)" }} />
    <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
      <Reveal>
        <h2 className="section-title text-3xl md:text-4xl text-white mb-5">Ready When You Are</h2>
        <p className="font-serif-el text-xl text-white/90 mb-8">
          Please reach out to Roger and Whitney for a remarkable home selling and buying experience.
        </p>
        <a
          href={`tel:${CONTACT.phoneRaw}`}
          className="inline-flex items-center gap-3 bg-white text-[#3a3736] px-8 py-4 rounded-sm font-sans-el tracking-[0.14em] uppercase text-sm hover:bg-[#b6a4a7] hover:text-white transition-all duration-300"
        >
          <Phone size={17} /> Call Roger: {CONTACT.phone}
        </a>
      </Reveal>
    </div>
  </section>
);
